export default "__VITE_ASSET__ehrMHTdJ__"